import { render, staticRenderFns } from "./ropularity.vue?vue&type=template&id=7efd96d5&scoped=true&"
import script from "./ropularity.vue?vue&type=script&lang=js&"
export * from "./ropularity.vue?vue&type=script&lang=js&"
import style0 from "./ropularity.vue?vue&type=style&index=0&id=7efd96d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd96d5",
  null
  
)

export default component.exports